import PropTypes from 'prop-types';
import MaskedFiel from './MaskedField';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

class DecimalField extends MaskedFiel {
    constructor(props){
        super(props);
        this.state = {
            ...this.state, mask: createNumberMask({
                prefix: '',
                suffix: '',
                thousandsSeparatorSymbol: ' ',
                allowDecimal: true,
                decimalSymbol: '.',
                decimalLimit: 2
            })};
    }
}

DecimalField.propTypes= {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
}

export default DecimalField


// WEBPACK FOOTER //
// ./src/components/custom/DecimalField.js